import { createStore, type Store } from "@quotientjs/browser-storage"
import { z } from "zod"

export const SESSION_ID_STORAGE_KEY = "quotient-session-id"

export type SessionId = string

/**
 * Sessions must survive across tabs (per the on-site tracking spec), so this
 * is `localStorage`, not `sessionStorage` — a fresh tab should pick up the
 * same session rather than starting a new one.
 */
export const SessionIdStore: Store<SessionId, "local"> = createStore({
  key: SESSION_ID_STORAGE_KEY,
  validator: z.string(),
  storageType: "local",
})
